export const Beam = () => {
  return (
    <svg
      width={134}
      height={132}
      viewBox="0 0 134 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M43.087 39.94C28.536 52.41 26.875 74.281 39.36 88.802c12.494 14.522 34.42 16.188 48.962 3.719 14.551-12.47 16.212-34.35 3.717-48.863-12.494-14.52-34.42-16.178-48.962-3.71l.009-.008z"
        fill="url(#paint0_radial_6778_975)"
      />
      <path
        d="M66.55 63.52c-22.33-3.65-40.606-5.727-40.856-4.637-.241 1.1 17.657 4.947 39.96 8.596 22.323 3.65 40.608 5.72 40.849 4.638.241-1.091-17.65-4.938-39.961-8.597h.008z"
        fill="url(#paint1_linear_6778_975)"
      />
      <path
        d="M63.454 66.612c5.37 27.66 10.842 49.868 12.219 49.601 1.377-.266-1.867-22.903-7.245-50.571C63.058 37.99 53.111-.267 51.734 0c-1.377.266 6.342 38.952 11.72 66.612z"
        fill="url(#paint2_linear_6778_975)"
        fillOpacity={0.8}
      />
      <path
        d="M65.46 63.65c-27.718 5.367-49.97 10.828-49.704 12.194.267 1.374 22.95-1.864 50.666-7.23 27.717-5.36 49.969-10.821 49.703-12.195-.267-1.374-22.95 1.864-50.666 7.222v.009z"
        fill="url(#paint3_linear_6778_975)"
      />
      <path
        d="M65.02 66.106c-7.813 12.289-13.673 22.576-13.088 22.997.585.421 7.4-9.197 15.222-21.468 7.814-12.28 13.674-22.577 13.088-22.997-.585-.421-7.4 9.188-15.222 21.468z"
        fill="url(#paint4_linear_6778_975)"
      />
      <path
        d="M66.784 65.762c-11.84-8.458-21.753-14.83-22.14-14.229-.386.61 8.898 7.97 20.747 16.436 11.84 8.459 21.753 14.84 22.14 14.23.387-.61-8.898-7.97-20.747-16.445v.008z"
        fill="url(#paint5_linear_6778_975)"
      />
      <path
        d="M64.94 64.912c-32.699 36.17-58.445 66.183-57.507 67.016.938.842 28.199-27.797 60.898-63.968 32.69-36.17 58.436-66.174 57.506-67.016-.938-.841-28.198 27.798-60.897 63.968z"
        fill="url(#paint6_linear_6778_975)"
        fillOpacity={0.3}
      />
      <path
        d="M65.14 68.158c36.793 32.014 67.289 57.201 68.116 56.248.826-.945-28.328-27.67-65.114-59.683C31.347 32.71.842 7.523.016 8.467-.81 9.412 28.344 36.136 65.14 68.15v.008z"
        fill="url(#paint7_linear_6778_975)"
        fillOpacity={0.5}
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M26.415 86.86a1.353 1.353 0 01-2.624-.661 1.353 1.353 0 012.624.661z"
        fill="url(#paint8_radial_6778_975)"
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M33.817 83.117a1.354 1.354 0 01-2.625-.661 1.354 1.354 0 012.625.661z"
        fill="url(#paint9_radial_6778_975)"
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M44.049 84.405c-1.377 5.418-6.893 8.707-12.323 7.333-5.43-1.374-8.717-6.878-7.348-12.297 1.376-5.419 6.892-8.707 12.322-7.334 5.438 1.374 8.725 6.879 7.349 12.298z"
        fill="url(#paint10_radial_6778_975)"
        opacity={0.2}
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M92.195 74.355c4.892-14.09-2.588-29.469-16.706-34.35-14.118-4.882-29.528 2.582-34.42 16.672-4.89 14.089 2.588 29.468 16.706 34.35 14.118 4.882 29.53-2.583 34.42-16.672z"
        fill="url(#paint11_radial_6778_975)"
        opacity={0.15}
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M79.751 68.828c-1.833 7.23-9.19 11.601-16.436 9.772-7.244-1.83-11.624-9.171-9.791-16.402 1.832-7.23 9.19-11.602 16.434-9.772 7.246 1.829 11.626 9.17 9.793 16.401z"
        fill="url(#paint12_radial_6778_975)"
        opacity={0.5}
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M77.564 68.278c-1.531 6.02-7.658 9.67-13.7 8.15-6.031-1.529-9.688-7.643-8.165-13.672 1.532-6.02 7.658-9.669 13.699-8.149 6.032 1.529 9.689 7.643 8.166 13.671z"
        fill="url(#paint13_radial_6778_975)"
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M51.121 125.282l1.024.257 13.622-54.401-2.418 40.275 1.05.06 2.358-39.296 1.781 18.042 1.05-.103-2.04-20.661 8.76 23.306.981-.37-2.332-6.2 9.276 21.521.964-.412-12.39-28.786 14.257 27.403.93-.481L68.84 68.622l26.116 27.643.766-.721-23.698-25.085 14.353 11.37.654-.824-5.886-4.663 4.337 3.048.06-.094 14.895 10.356.603-.867-21.65-15.045 38.068 22.714.542-.902-44.574-26.595 13.166 5.564.413-.97-13.949-5.891 53.472 13.328.249-1.014L72.264 66.38l40.357 2.413.06-1.047-39.367-2.362 18.07-1.769-.103-1.047-20.704 2.035 23.354-8.742-.37-.988-6.204 2.327 21.564-9.248-.413-.962-28.853 12.366 27.459-14.23-.482-.935-36.889 19.115L97.45 37.252l-.722-.764-25.144 23.64 11.402-14.315-.827-.66-4.68 5.89 3.054-4.336-.094-.06 10.377-14.874-.869-.592-15.076 21.605 22.77-37.999-.905-.532-26.658 44.483 5.576-13.148-.972-.403-5.903 13.92L82.142 5.745l-1.024-.258-13.62 54.401 2.417-40.266-1.05-.069-2.358 39.296-1.78-18.033-1.05.103 2.038 20.661-8.759-23.315-.98.37 2.331 6.208-9.277-21.528-.963.412 12.4 28.793-14.268-27.41-.929.489 19.155 36.814-26.108-27.651-.766.72 23.69 25.085-14.353-11.37-.654.824 5.894 4.672-4.345-3.049-.06.086-14.896-10.348-.602.86 21.65 15.053-38.068-22.722-.542.901 44.573 26.604-13.165-5.565-.413.962 13.948 5.9-53.47-13.336-.25 1.021L61 64.654l-40.357-2.413-.069 1.048 39.376 2.353-18.07 1.769.103 1.047 20.703-2.026-23.353 8.733.37.988 6.212-2.327-21.572 9.248.421.97L53.608 71.67 26.15 85.908l.482.928 36.89-19.116-27.709 26.054.723.764 25.144-23.64L50.278 85.22l.826.653 4.681-5.883-3.054 4.337.094.06-10.377 14.865.87.6 15.075-21.605-22.769 37.991.903.541 26.66-44.492-5.577 13.148.972.412 5.903-13.92-13.364 53.354z"
        fill="url(#paint14_radial_6778_975)"
        opacity={0.03}
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M52.18 87.754c-2.753 10.846-13.785 17.407-24.653 14.668-10.868-2.748-17.442-13.758-14.697-24.603 2.753-10.846 13.785-17.407 24.653-14.66 10.868 2.749 17.442 13.758 14.689 24.604l.008-.009z"
        fill="url(#paint15_radial_6778_975)"
        opacity={0.5}
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M69.847 65.847a2.663 2.663 0 01-5.163-1.305 2.665 2.665 0 013.236-1.923 2.653 2.653 0 011.927 3.228z"
        fill="url(#paint16_radial_6778_975)"
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M53.377 75.68a4.698 4.698 0 01-5.705 3.393 4.687 4.687 0 01-3.4-5.694 4.698 4.698 0 015.706-3.392 4.687 4.687 0 013.399 5.694z"
        fill="url(#paint17_radial_6778_975)"
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M48.903 76.788a3.126 3.126 0 01-3.795 2.259 3.121 3.121 0 01-2.263-3.787 3.124 3.124 0 016.058 1.528z"
        fill="url(#paint18_radial_6778_975)"
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M39.893 83.624c-.844 3.315-4.217 5.324-7.547 4.491a6.197 6.197 0 01-4.492-7.53 6.216 6.216 0 017.547-4.492 6.205 6.205 0 014.5 7.531h-.008z"
        fill="url(#paint19_radial_6778_975)"
      />
      <path
        style={{
          mixBlendMode: "screen",
        }}
        d="M43.575 81.82c-.852 3.367-4.285 5.402-7.66 4.552a6.282 6.282 0 01-4.56-7.634c.853-3.366 4.278-5.401 7.65-4.551a6.282 6.282 0 014.56 7.634h.01z"
        fill="url(#paint20_radial_6778_975)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 34.6506 -34.7196 0 65.704 66.233)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <linearGradient
          id="paint1_linear_6778_975"
          x1={57.1148}
          y1={62.5306}
          x2={56.7748}
          y2={64.3616}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDF7F0" stopOpacity={0.58} />
          <stop offset={1} stopColor="#F7E5D2" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6778_975"
          x1={61.067}
          y1={33.1331}
          x2={58.092}
          y2={33.7092}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDF7F0" stopOpacity={0.58} />
          <stop offset={1} stopColor="#F7E5D2" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6778_975"
          x1={54.7823}
          y1={61.8215}
          x2={54.2133}
          y2={64.4485}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDF7F0" stopOpacity={0.58} />
          <stop offset={1} stopColor="#F7E5D2" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6778_975"
          x1={62.9309}
          y1={57.3095}
          x2={60.2649}
          y2={58.8778}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDF7F0" stopOpacity={0.58} />
          <stop offset={1} stopColor="#F7E5D2" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6778_975"
          x1={61.3175}
          y1={60.2596}
          x2={59.2745}
          y2={62.8878}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDF7F0" stopOpacity={0.58} />
          <stop offset={1} stopColor="#F7E5D2" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6778_975"
          x1={71.4}
          y1={55.5691}
          x2={77.872}
          y2={62.1322}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDF7F0" stopOpacity={0.58} />
          <stop offset={1} stopColor="#F7E5D2" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint7_linear_6778_975"
          x1={51.8202}
          y1={41.5115}
          x2={43.8802}
          y2={49.9211}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDF7F0" stopOpacity={0.58} />
          <stop offset={1} stopColor="#F7E5D2" stopOpacity={0} />
        </linearGradient>
        <radialGradient
          id="paint8_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 1.35013 -1.35289 0 25.103 86.53)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint9_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 1.35013 -1.35289 0 32.504 82.786)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint10_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 10.1277 -10.1472 0 34.215 81.923)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint11_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(19.074 -161.665 231.063) scale(27.0481 27.0047)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint12_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 13.5033 -13.5309 0 66.638 65.513)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint13_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 11.2549 -11.2779 0 66.632 65.517)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint14_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 60.026 -60.1443 0 66.632 65.513)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint15_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 20.2547 -20.2961 0 32.502 82.789)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint16_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 2.65848 -2.66391 0 67.266 65.195)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint17_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 4.68723 -4.69681 0 48.825 74.53)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint18_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 3.11799 -3.12437 0 45.874 76.024)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint19_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 6.20083 -6.21404 0 33.876 82.103)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="paint20_radial_6778_975"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 6.28592 -6.29877 0 37.46 80.28)"
        >
          <stop stopColor="#EEEBDD" />
          <stop offset={1} stopColor="#EEEBDD" stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  );
};
